export default {
    fontFamily: "RussoOne",
    DPR: 1,
    viewbox: {
        x: 25,
        y: 25,
    },
    joystick: {
        x: 175,
        y: 300,
    },
};
